import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { AppState } from 'src/app/store/state/app.state'
import { InitializeState } from 'src/app/store/state/initial.state'
import { getEnabledModules } from 'src/app/store/selector/initialize.selector'

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  readonly DASHBOARD = `/${GlobalConstants.ROUTING.DASHBOARD}`
  readonly ACTIVITY_DASHBOARD = `/${GlobalConstants.ROUTING.ACTIVITY}/${GlobalConstants.ROUTING.DASHBOARD}`
  readonly QUERY_DASHBOARD = `/${GlobalConstants.ROUTING.QUERY}/${GlobalConstants.ROUTING.DASHBOARD}`
  readonly PROFILE = `/${GlobalConstants.ROUTING.PROFILE}`
  readonly KNOWLEDGE_HUB = `/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/${GlobalConstants.ROUTING.SEARCH}`
  readonly SETTINGS = `/${GlobalConstants.ROUTING.SETTINGS}`
  readonly HELP = `/${GlobalConstants.ROUTING.HELP}/${GlobalConstants.ROUTING.TUTORIAL_INFO}`
  companyLogoUrl$: Observable<string>
  initialized$: Observable<boolean>
  showHelpPage$: Observable<boolean>
  enabledModules$: Observable<string[]>

  constructor(private readonly appState: Store<AppState>) {}

  ngOnInit() {
    this.companyLogoUrl$ = this.appState.select(
      (state: { initialize: InitializeState }) => state.initialize.companyLogoUrl
    )

    this.showHelpPage$ = this.appState.select(() => true)

    this.initialized$ = this.appState.select((state: { initialize: InitializeState }) => state.initialize.initialized)

    this.enabledModules$ = this.appState.select(getEnabledModules)
  }
}
